import React, { useCallback } from "react";
import { Button, FormControl, Grid, TextField, MenuItem } from "@material-ui/core";
import { Edit } from "@material-ui/icons";
import { Formik } from "formik";
import { roomSchema, useStyleFormAssignRoom } from "../helpers/AssignBuildEvtOption";
import SelectDropOtions from "../../../../components/SelectDropOtions";

const FormRoom = ({
    onSubmit = () => {},
    initialFormValues = {},
    isCreateForm = true,
    buildingOption = [],
    floorOption = [],
}) => {
    const classes = useStyleFormAssignRoom();

    // select building
    const handleSelectBuilding = useCallback(async (values, setFieldValue) => {
        await setFieldValue("floorId", "");
        await setFieldValue("buildingId", values);
    }, []);

    // select floor
    const handleSelectFloor = useCallback(async (values, setFieldValue) => {
        await setFieldValue("floorId", values);
    }, []);

    // select status
    const handleSelectPermissionStatus = useCallback(async (values, setFieldValue) => {
        await setFieldValue("status", values);
    }, []);

    return (
        <Formik initialValues={initialFormValues} validationSchema={roomSchema} onSubmit={onSubmit}>
            {({ handleChange, handleSubmit, setFieldValue, values, errors }) => (
                <Grid container spacing={4} className="px-5">
                    <Grid item xs={12} sm={isCreateForm ? 6 : 12} lg={isCreateForm ? 4 : 12}>
                        <Grid container spacing={0} className="align-items-center">
                            <Grid item xs={5}>
                                <label className="mb-0">
                                    เลือกอาคาร <span className="text-danger">*</span>
                                </label>
                            </Grid>
                            <Grid item xs={7}>
                                <SelectDropOtions
                                    containerClass={`${classes.border} ${classes.select}`}
                                    options={buildingOption}
                                    placeholder="Select Build..."
                                    value={values?.buildingId}
                                    onChange={val => handleSelectBuilding(val, setFieldValue)}
                                    error={Boolean(errors?.buildingId)}
                                    helperText={errors?.buildingId}
                                    renderOption={row => (
                                        <MenuItem value={row?.buildingId} key={row?.buildingId + "_b"}>
                                            {row?.name}
                                        </MenuItem>
                                    )}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} sm={isCreateForm ? 6 : 12} lg={isCreateForm ? 3 : 12}>
                        <Grid container spacing={0} className="align-items-center">
                            <Grid item xs={5}>
                                <label className="mb-0">
                                    ระบุชั้น <span className="text-danger">*</span>
                                </label>
                            </Grid>
                            <Grid item xs={7}>
                                <SelectDropOtions
                                    containerClass={`${classes.border} ${classes.select}`}
                                    options={floorOption?.filter(item => item?.buildingId === values?.buildingId)}
                                    placeholder="Select Floor..."
                                    value={values?.floorId}
                                    onChange={val => handleSelectFloor(val, setFieldValue)}
                                    error={Boolean(errors?.floorId)}
                                    helperText={errors?.floorId}
                                    renderOption={row => (
                                        <MenuItem value={row?.floorId} key={row?.floorId + "_b"}>
                                            {row?.name} / {row?.locationName}
                                        </MenuItem>
                                    )}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} sm={isCreateForm ? 6 : 12} lg={isCreateForm ? 4 : 12}>
                        <Grid container spacing={0} className="align-items-center">
                            <Grid item xs={5}>
                                <label className="mb-0">
                                    สถานะห้อง <span className="text-danger">*</span>
                                </label>
                            </Grid>
                            <Grid item xs={7}>
                                <SelectDropOtions
                                    containerClass={`${classes.border} ${classes.select}`}
                                    options={[
                                        { id: "0", title: "ห้องตรวจ" },
                                        { id: "1", title: "ห้องรับยา" },
                                        { id: "2", title: "ห้องการเงิน" },
                                    ]}
                                    placeholder="Select..."
                                    value={values?.status}
                                    onChange={val => handleSelectPermissionStatus(val, setFieldValue)}
                                    error={Boolean(errors?.status)}
                                    helperText={errors?.status}
                                    renderOption={row => (
                                        <MenuItem value={row?.id} key={row?.id + "_b"}>
                                            {row?.title}
                                        </MenuItem>
                                    )}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} sm={isCreateForm ? 6 : 12} lg={isCreateForm ? 4 : 12}>
                        <Grid container spacing={0} className="align-items-center">
                            <Grid item xs={5}>
                                <label className="mb-0">
                                    ชื่อห้อง <span className="text-danger">*</span>
                                </label>
                            </Grid>
                            <Grid item xs={7}>
                                <FormControl className="t-form-group-custom w-100">
                                    <TextField
                                        className={`h-100 ${classes.input}`}
                                        InputProps={{
                                            endAdornment: <Edit />,
                                        }}
                                        fullWidth
                                        size="small"
                                        type="text"
                                        name="roomName"
                                        label="ชื่อห้อง..."
                                        variant="outlined"
                                        value={values?.roomName}
                                        onChange={handleChange}
                                        error={Boolean(errors?.roomName)}
                                        helperText={errors?.roomName}
                                        FormHelperTextProps={{
                                            className: "text-danger position-absolute",
                                            style: { bottom: -25, left: 0 },
                                        }}
                                    />
                                </FormControl>
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid item xs={12} sm={isCreateForm ? 6 : 12} lg={isCreateForm ? 3 : 12}>
                        <Grid container spacing={0} className="align-items-center">
                            <Grid item xs={5}>
                                <label className="mb-0">
                                    ชื่อห้องภาษาอังกฤษ <span className="text-danger">*</span>
                                </label>
                            </Grid>
                            <Grid item xs={7}>
                                <FormControl className="t-form-group-custom w-100">
                                    <TextField
                                        className={`h-100 ${classes.input}`}
                                        InputProps={{
                                            endAdornment: <Edit />,
                                        }}
                                        fullWidth
                                        size="small"
                                        type="text"
                                        name="roomNameEnglish"
                                        label="ชื่อห้องภาษาอังกฤษ..."
                                        variant="outlined"
                                        value={values?.roomNameEnglish}
                                        onChange={handleChange}
                                        error={Boolean(errors?.roomNameEnglish)}
                                        helperText={errors?.roomNameEnglish}
                                        FormHelperTextProps={{
                                            className: "text-danger position-absolute",
                                            style: { bottom: -25, left: 0 },
                                        }}
                                    />
                                </FormControl>
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid item xs={12} sm={isCreateForm ? 2 : 12} lg={isCreateForm ? 4 : 12}>
                        <Grid className="d-flex align-items-center justify-content-end h-100">
                            <Grid item xs={0} className="h-100">
                                <Button onClick={handleSubmit} className="t-btn-primary w-100 h-100">
                                    {isCreateForm ? "Add" : "Edit"}
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            )}
        </Formik>
    );
};

export default FormRoom;
